module.exports = {
    "container": "mc672246fa_container",
    "header": "mc672246fa_header",
    "content": "mc672246fa_content"
};